"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _nuiAuth.getSigninUrl;
  }
});
Object.defineProperty(exports, "redirectToSignin", {
  enumerable: true,
  get: function get() {
    return _nuiAuth.redirectToSignin;
  }
});
var _nuiAuth = require("@concur/nui-auth");